<template>
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" @click="on_click()">
		<path fill-rule="evenodd" clip-rule="evenodd" d="M14 3H10V4H14V3ZM5.5 13C5.5 9.41243 8.41243 6.5 12 6.5C15.5876 6.5 18.5 9.41243 18.5 13C18.5 16.5876 15.5876 19.5 12 19.5C8.41243 19.5 5.5 16.5876 5.5 13ZM12 5C7.584 5 4 8.584 4 13C4 17.416 7.584 21 12 21C16.416 21 20 17.416 20 13C20 8.584 16.416 5 12 5Z" :fill="fill_color" :fill-opacity="opacity"/>
		<rect x="20.2738" y="6.93365" width="4" height="1" transform="rotate(66.2639 20.2738 6.93365)" :fill="fill_color" :fill-opacity="opacity"/>
		<path d="M12.5 8H11V14L16.2 17.2L17 15.9L12.5 13.2V8Z" :fill="fill_color" :fill-opacity="opacity"/>
	</svg>
</template>

<script>
import base_icon from '@/components/icons/base_icon';

export default {
	extends: base_icon
}
</script>